<!--
 * @Description: 散活作业详情
 * @Author: zhanghongquan
 * @Date: 2022-04-01 16:47:26
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-13 17:32:16
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="title-wrap">
        <h2 class="title">
          <span class="txt">作业查看</span>
        </h2>
      </div>
      <div class="message-flex">
        <div class="flex-left">
          <div class="title-content vertical-line">
            <h2 class="title">
              <span class="txt">机手信息</span>
            </h2>
          </div>
          <table class="table-info" width="100%" cellspacing="0">
            <tr>
              <td
                width="1%"
                class="info"
                rowspan="4"
                style="text-align: center"
              >
                <el-image
                  :src="employeeDetail.employeePhotoUrl"
                  :fit="'scale-down'"
                  style="width: 120px; height: 160px"
                >
                </el-image>
              </td>
              <td width="10%" class="title">姓名</td>
              <td width="22%" class="info">
                {{ employeeDetail.employeeName }}
              </td>
            </tr>
            <tr>
              <td width="10%" class="title">身份证号</td>
              <td width="22%" class="info">{{ employeeDetail.idCard }}</td>
            </tr>
            <tr>
              <td width="10%" class="title">手机号</td>
              <td width="22%" class="info">{{ employeeDetail.mobile }}</td>
            </tr>
            <tr>
              <td width="10%" class="title">住址</td>
              <td width="22%" class="info">{{ employeeDetail.address }}</td>
            </tr>
          </table>
        </div>
        <div class="flex-right">
          <div class="title-content vertical-line">
            <h2 class="title">
              <span class="txt">机具信息</span>
            </h2>
          </div>
          <table class="table-info" width="100%" cellspacing="0">
            <tr>
              <td
                width="1%"
                class="info"
                rowspan="4"
                style="text-align: center"
              >
                <el-image
                  :src="machineDetail.machineryUrl"
                  :fit="'scale-down'"
                  style="width: 120px; height: 160px"
                >
                </el-image>
              </td>
              <td width="10%" class="title">农机品目</td>
              <td width="22%" class="info">
                {{ machineDetail.categoryName3 }}
              </td>
            </tr>
            <tr>
              <td width="10%" class="title">农机型号</td>
              <td width="22%" class="info">
                {{ machineDetail.machineryModel }}
              </td>
            </tr>
            <tr>
              <td width="10%" class="title">出厂编号</td>
              <td width="22%" class="info">
                {{ machineDetail.machineryCode }}
              </td>
            </tr>
            <tr>
              <td width="10%" class="title">北斗终端编号</td>
              <td width="22%" class="info">{{ machineDetail.imei }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="title-content vertical-line">
        <h2 class="title">
          <span class="txt">农机作业</span>
        </h2>
      </div>
      <el-table :data="workInfo" border style="width: 100%">
        <el-table-column
          prop="workDate"
          label="作业日期"
          min-width="18%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          prop="workTypeName"
          label="作业类型"
          min-width="32%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          label="作业面积"
          min-width="15%"
          align="center"
          :resizable="false"
        >
          <template slot-scope="scope">{{ scope.row.workArea }}亩</template>
        </el-table-column>
        <el-table-column
          label="作业时间"
          min-width="35%"
          align="center"
          :resizable="false"
        >
          <template slot-scope="scope">{{ scope.row.workTime }}小时</template>
        </el-table-column>
        <el-table-column
          label="行驶里程"
          min-width="35%"
          align="center"
          :resizable="false"
        >
          <template slot-scope="scope">{{ scope.row.mileage }}公里</template>
        </el-table-column>
      </el-table>
      <div class="title-content vertical-line">
        <h2 class="title">
          <span class="txt">作业轨迹</span>
        </h2>
      </div>
      <div class="map">
        <Trajectory
          v-if="imei"
          :imei="imei"
          :workStartTime="workStartTime"
          :workEndTime="workEndTime"
          :iotType="iotType"
        ></Trajectory>
      </div>
    </div>
  </el-main>
</template>

<script>
import Trajectory from "./components/OrderWorkTrajectory";
export default {
  components: {
    Trajectory,
  },
  data() {
    return {
      id: "",
      employeeId: "",
      machineIdentity: "",
      employeeDetail: "",
      machineDetail: "",
      workInfo: [],
      imei: "",
      workStartTime: "",
      workEndTime: "",
      iotType: "",
    };
  },
  mounted() {
    let { id, employeeId, machineIdentity, imei, workTime, iotType } =
      this.$route.query;
    this.id = id;
    this.employeeId = employeeId;
    this.machineIdentity = machineIdentity;
    this.imei = imei;
    this.workStartTime = workTime;
    this.workEndTime = workTime;
    this.iotType = iotType;
    this.getEmployeeDetail();
    this.getMachineDetailByMachineIdentity();
    this.getXScanCodeWorkById();
  },
  methods: {
    /**
     * @descripttion: 获取机手信息
     * @Author: juanjuanhui
     * @Date: 2021-11-25 10:45:30
     */
    getEmployeeDetail() {
      this.$http.personnel
        .getEmployeeDetail({ employeeId: this.employeeId })
        .then((res) => {
          this.employeeDetail = res.data;
        });
    },
    /**
     * @descripttion: 获取机具信息
     * @Author: juanjuanhui
     * @Date: 2022-04-22 09:24:33
     */
    getMachineDetailByMachineIdentity() {
      this.$http.work
        .getMachineDetailByMachineIdentity({
          machineIdentity: this.machineIdentity,
        })
        .then((res) => {
          this.machineDetail = res.data;
          this.imei = res.data.imei;
        });
    },
    /**
     * @descripttion: 获取农机作业信息
     * @Author: juanjuanhui
     * @Date: 2022-04-22 09:41:48
     */
    getXScanCodeWorkById() {
      this.$http.work.getXScanCodeWorkById({ id: this.id }).then((res) => {
        this.workInfo = [res.data];
        let { workDate } = res.data;
        this.workStartTime = workDate;
        this.workEndTime = workDate;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
@import "@/styles/mixin.scss";
.main {
  padding-top: 0 !important;
  .message-flex {
    display: flex;
    justify-content: space-between;
    .flex-left {
      flex: 1;
    }
    .flex-right {
      flex: 1;
      margin-left: 10px;
    }
  }
  .title-wrap {
    @include plate-title-mutil;
    height: 55px;
    border-bottom: 1px solid #e9ebee;
  }
  .title-content {
    @include plate-title-mutil;
    border: none;
    margin-top: 10px;
    .txt {
      color: #333333 !important;
    }
  }
  .table-info {
    &:first-child {
      margin-right: 10px;
    }
    .machine {
      width: 150px;
      height: 120px;
    }
    .qr-code {
      width: 108px;
      height: 118px;
    }
    .el-image {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
